import React from 'react';

const WarningIcon = () => {
	return (
		<svg
			fill="#ffd96a"
			version="1.1"
			id="Capa_1"
			xmlns="http://www.w3.org/2000/svg"
			width="48"
			x="0px"
			y="0px"
			viewBox="0 0 52 52"
			style={{ enableBackground: 'new 0 0 52 52', marginRight: '15px' }}
			xmlSpace="preserve">
			<g>
				<path
					d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26
		S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z"
				/>
				<path d="M26,10c-0.552,0-1,0.447-1,1v22c0,0.553,0.448,1,1,1s1-0.447,1-1V11C27,10.447,26.552,10,26,10z" />
				<path d="M26,37c-0.552,0-1,0.447-1,1v2c0,0.553,0.448,1,1,1s1-0.447,1-1v-2C27,37.447,26.552,37,26,37z" />
			</g>
		</svg>
	);
};

export default WarningIcon;
